import { styled } from "@mui/material/styles";
import { Box, Typography, Grid2 } from "@mui/material";
import { colors } from "../../../theme/theme";

export const InfoText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  color: colors.primary,
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  marginLeft: 32,
  marginRight: 32,
  marginTop: 16,
  marginBottom: 8,
}));

export const SectionHeader = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: theme.spacing(2),
  color: colors.primary,
  textAlign: "left",
  marginTop: 16,
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
  },
}));

export const SectionHeaderWithMargin = styled(SectionHeader)({
  marginTop: 4,
  marginBottom: 24,
});

export const FieldLabel = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  color: colors.primary,
  fontWeight: 600,
  marginBottom: 8,
  minHeight: "24px",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
    textWrap: "nowrap",
  },
}));

export const ContentBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingLeft: 32,
  paddingRight: 32,
  paddingTop: 16,
  paddingBottom: 16,
});

export const ImageUploadWrapper = styled(Box)({
  display: "flex",
  width: "fit-content",
  flexDirection: "column",
  alignItems: "start",
});

export const AvatarBox = styled(Box)({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px dashed rgba(73, 42, 24, 1)",
  borderRadius: "14px",
  backgroundColor: "rgba(73, 42, 24, 0.05)",
  height: "110px",
  width: "110px",
  cursor: "pointer",
});

export const AvatarImage = styled("img")({
  height: "100%",
  width: "100%",
  objectFit: "cover",
  borderRadius: "14px",
});

export const AvatarOverlay = styled(Box)({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "14px",
  backgroundColor: "rgba(73, 42, 24, 0.05)",
});

export const AutoSaveStatusText = styled(Typography)(({ $isSaving }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "13px",
  color: $isSaving ? "#999" : "#4caf50",
  marginLeft: 32,
  marginRight: 32,
  marginTop: 4,
  marginBottom: 0,
  display: "flex",
  alignItems: "center",
  gap: 4,
}));

export const SpecialtiesGrid = styled(Grid2)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
  width: "100%",
}));

export const FormRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: theme.spacing(2),
  "& > *": {
    flex: "none",
    minWidth: "100%",
    width: "100%",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    "& > *": {
      flex: 1,
      minWidth: 0,
      width: "auto",
    },
  },
}));

export const StatusSectionRoot = styled(Box)({
  width: "100%",
});

export const SocialsGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  gap: theme.spacing(2),
  width: "100%",
  "& > *": {
    flex: "none",
    minWidth: "100%",
    width: "100%",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    "& > *": {
      flex: "1 1 calc(50% - 8px)",
      minWidth: 0,
      width: "auto",
    },
  },
}));

export const FormFieldBoxRoot = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  "@media (min-width: 600px)": {
    width: "50%",
  },
});
